import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import ErrorBoundaryFallback from '@components/error-boundary-fallback'

interface AbsoluteContainerProps {
  children: React.ReactNode
}

function AbsoluteContainer({ children }: AbsoluteContainerProps) {
  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
      <div className="absolute h-full w-full bg-neutralColour">{children}</div>
    </ErrorBoundary>
  )
}

export default AbsoluteContainer
